import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';

export const useStyles: any = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.primary,
    },
    header: {
      fontSize: '1.6rem',
      // fontWeight: 750,
      color: theme.palette.secondary.main,
    },
    itemTitle: {
      color: theme.palette.primary.main,
    },
  }),
);
